module.exports = __webpack_public_path__ + "static/media/inc-analyze.fe976d2e.svg";